import type { Duration } from "date-fns";
import { add, format } from "date-fns";

import { parseDateIfItsValidAndMatchesFormat } from "./parseDateIfItsValidAndMatchesFormat";

export const calculateDateFromDuration = ({
    referenceDate,
    formatString,
    duration,
}: {
    referenceDate: string;
    formatString: string;
    duration: Duration;
}) => {
    const referenceDateParsed = parseDateIfItsValidAndMatchesFormat({
        dateString: referenceDate,
        formatString,
    });
    if (referenceDateParsed === false) {
        throw new Error("Invalid reference date format");
    }
    return format(add(referenceDateParsed, duration), formatString);
};
